//REACT
import React, {Fragment, useContext} from 'react';
import Button from '@material-ui/core/Button';

//MUI COMPONENTS
import {makeStyles, Typography, Paper, Grid, ButtonBase, Avatar, Container, Box} from '@material-ui/core';

//icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileAlt,faBook,faPoundSign, faChevronCircleRight } from '@fortawesome/free-solid-svg-icons'

//custom assets
import placeholderImg from '../assets/placehoplder_image.svg';

//custom contexts
import {ClientContext} from '../contexts/ClientContext';


const apiUrl = process.env.REACT_APP_API_URL_START + window.location.hostname.substr(window.location.hostname.split('.')[0].length) + process.env.REACT_APP_API_URL_END;

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        padding:theme.spacing(2),
        // marginLeft:46,
        // marginRight:46
    },
    propertyPaper: {
        padding: theme.spacing(3),
        textAlign: 'left',
        color: theme.palette.text.secondary,
        backgroundColor:'#f6f6f6',
        marginBottom: '15px'
    },
    image:{
        backgroundColor:'transparent',
        // ESPC no longer honours the &width=&height= params in the image URL,
        // so it returns the full-resolution image. Constrain it in CSS to the
        // intended box regardless of the source dimensions.
        '& img':{
            display:'block',
            width:360,
            height:240,
            maxWidth:'100%',
            objectFit:'cover'
        },
        [theme.breakpoints.down("sm")]: {
            marginBottom:10,
            width:'100%',
            '& img':{
                width:'100%',
                height:200
            }
        }
    },
    titleBox: {
        padding: theme.spacing(2),
        marginTop:66,
        marginBottom:46,
        textAlign: 'left',
        color: theme.palette.primary.main,
        fontFamily:"Cabin",
        fontSize:'46px',
        fontWeight:'bold',
        [theme.breakpoints.down("sm")]: {
            fontSize:36,
            lineHeight:1.3
        },
        // marginLeft:46,
        // marginRight:46
    },
    propertyTitle:{
        fontFamily: "Cabin",
        fontSize: '24px',
        fontWeight: 'bold',
        lineHeight:'29px',
        color:theme.palette.primary.main
    },
    propertyDetails:{
        fontFamily: "Cabin",
        fontSize: '18px',
        fontWeight: 'normal',
        color:theme.palette.text.secondary
    },
    gotoButton:{
        backgroundColor:theme.palette.primary.main,
        fontSize:14,
        fontWeight:'bold',
        color:'#FFFFFF',
        borderRadius:0,
        '&:hover':{
            color:theme.palette.primary.main,
            backgroundColor:'#FFFFFF',
        },
        '& .gotoIcon':{
          fontSize:18
        },
        width:225,
        height:45,
        [theme.breakpoints.down("sm")]: {
            width:230
        },
    },
    downloadButton:{
        borderRadius:0,
        backgroundColor:'#FFFFFF',
        fontSize:12,
        fontWeight:500,
        color:theme.palette.primary.main,
        marginBottom:10,
        textAlign:'left',
        justifyContent:'left',
        '& .AvatarCircle':{
            width:18,
            height:18,
            fontSize:11,
            backgroundColor:theme.palette.primary.main,
            color:'#FFFFFF'
        },
        '& .downloadButtonIcon':{
            fontSize:11,
        },
        '&:hover':{
            backgroundColor:theme.palette.primary.main,
            color:'#FFFFFF',
            '& .AvatarCircle':{
                color:theme.palette.primary.main,
                backgroundColor:'#FFFFFF'
            },
        },
        width:230,
        height:40
    },
    detailsBox:{
        paddingBottom:30,
        [theme.breakpoints.down("sm")]: {
            paddingBottom:0,
        },

    },
    boldDetail:{
      fontWeight:'bold'
    },
    detailContainer:{
        marginLeft:20,
        marginRight:20
    }
}));

function PipList() {
    const context = useContext(ClientContext);
    const classes = useStyles();

    const { innerWidth: width, innerHeight: height } = window;
    const miniMobile = (width < 700);
    const bigWidth = (width > 900);


    return (
        <Fragment>
            <Container>
            <div className={classes.titleBox}>Properties you are considering</div>
            {context.pips.slice().reverse().map((res, index) => (
                <div className={classes.root} key={'todo ' + index}>
                    <Paper className={classes.propertyPaper} elevation={3} square={true}>
                        <Grid container spacing={4}>
                            {/*DESCRIPTION*/}
                            <Grid item >
                                 <div >
                                    <ButtonBase className={classes.image} href={"/pip/"+res.fcase_id}>
                                        {miniMobile ?
                                            <>
                                                {res.thumb ?
                                                    <img width="100%" src={res.thumb + '&width=360&height=240'} alt=""/>
                                                    :
                                                    <img width="100%" height="" src={placeholderImg} alt=""/>
                                                }
                                            </>
                                            :
                                            <>
                                                {res.thumb ?
                                                    <img src={res.thumb + '&width=360&height=240'} alt=""/>
                                                    :
                                                    <img width="360" height="" src={placeholderImg} alt=""/>
                                                }
                                            </>
                                        }

                                    </ButtonBase>
                                 </div>
                            </Grid>

                            <Grid item xs={12} sm  >
                                <Box display="flex" alignItems="center" height={'100%'}>
                                    <Box>
                                        <div className={classes.detailContainer}>
                                            <Typography gutterBottom className={classes.propertyTitle}>
                                                {res.property_address}
                                            </Typography>
                                            <div className={classes.detailsBox}>
                                                <Typography gutterBottom className={classes.propertyDetails}>
                                                    {res.price_qualifier_label && <span>{res.price_qualifier_label}: </span>}  <span className={classes.boldDetail}>{context.outputCurrency(res.askingPrice)}</span><br/>
                                                    {res.hrValue > 0 && <span>Home Report Value: <span className={classes.boldDetail}>{context.outputCurrency(res.hrValue)}</span><br/></span>}
                                                    {res.daysOnMarket > 0 && <span>Time on Market: {res.daysOnMarket}</span>}
                                                </Typography>
                                            </div>
                                            {!miniMobile && <Button variant="contained" className={classes.gotoButton} endIcon={<FontAwesomeIcon className="gotoIcon" icon={faChevronCircleRight} />} href={"/pip/"+res.fcase_id} >View offer help guide</Button>}
                                        </div>

                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={miniMobile ? 12 : 0} >
                                <Box display="flex" alignItems="center" justifyContent="center" height={'100%'}>
                                    <Box>
                                        {miniMobile &&
                                        <>
                                            <Button fullWidth={true} variant="contained" className={classes.gotoButton} endIcon={<FontAwesomeIcon className="gotoIcon" icon={faChevronCircleRight} />} href={"/pip/"+res.fcase_id} >View offer help guide</Button>
                                            <br/><br/>
                                        </>

                                        }
                                        <Button variant="outlined" fullWidth={true} className={classes.downloadButton} startIcon={<Avatar className="AvatarCircle"><FontAwesomeIcon className="downloadButtonIcon" icon={faFileAlt} /></Avatar>} href={apiUrl+'/file/'+res.hr_cdn_id+'/homereport'} >Download Home Report</Button>
                                        <br/>
                                        <Button variant="outlined" fullWidth={true} className={classes.downloadButton} startIcon={<Avatar className="AvatarCircle"><FontAwesomeIcon className="downloadButtonIcon" icon={faBook} /></Avatar>} href={apiUrl+'/file/'+res.brochure_cdn_id+'/brochure'} >Download Schedule</Button>
                                        <br/>
                                        <Button variant="outlined" fullWidth={true} className={classes.downloadButton} startIcon={<Avatar className="AvatarCircle"><FontAwesomeIcon className="downloadButtonIcon" icon={faPoundSign} /></Avatar>} href={apiUrl+'/fcase/'+res.fcase_id+'/budgetplanner/download'} >Download Budget Planner</Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>

                    </Paper>
                </div>
            ))}
            </Container>
        </Fragment>

    );
}

export default PipList;